import { Document, Image, Page, View } from '@react-pdf/renderer';
import optainBgImg from 'src/assets/img/optain-bg.png';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import Watermark from 'src/components/custom_components/CustomWatermark';

import { Session } from 'src/models/Session.model';

import { cls } from 'src/utils/reactPdfStyles';

import MainContent from './MainContent';

interface IOptainReportProps {
  session: Session;
}

const OptainReport = ({ session }: IOptainReportProps) => {
  const {
    practiceSettings: { watermark },
  } = useRemoteBoundStore.getState();
  return (
    <Document>
      <Page size="A4" style={cls('body')}>
        <Image src={optainBgImg} style={cls('optain_bg-report')} />

        <MainContent session={session} />

        {watermark ? <Watermark text={watermark} /> : <View></View>}
      </Page>
    </Document>
  );
};

export default OptainReport;
